import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { connect } from 'react-redux';
import { debounce } from '@beef/utils';
import { compose } from '@beef/redux';
import { withRenderFlag } from '@beef/react';
import { regionClick } from "../../store/common";
import { EFetchStatus, fetchAllRegions as _fetchAllRegions, fetchCartRegionList, fetchSuggestionsRegions, setSearchValue as _setSearchValue, toggleRegionModal as _toggleRegionModal } from "../../store/slices/region";
import { selectCartSuggestionsRegions, selectFetchAllRegionsStatus, selectFetchSuggestionsRegionsStatus, selectIsRegionModalOpen, selectPopularRegions, selectRegions, selectSearchValue, selectSuggestionsRegions } from "../../store/slices/region/selectors";
import { ActionBar, PopularRegions, RegionList, RegionModalLayout, Search, SearchResults } from "./components";
import { changeRegion } from "../../api/region";
export var RegionModalLayoutRC = compose(connect(function (state) {
  return {
    isOpen: selectIsRegionModalOpen(state),
    status: selectFetchAllRegionsStatus(state)
  };
}, function (dispatch) {
  return {
    fetchAllRegions: function fetchAllRegions(culture) {
      return dispatch(_fetchAllRegions(culture));
    },
    toggleRegionModal: function toggleRegionModal() {
      return dispatch(_toggleRegionModal());
    }
  };
}))(RegionModalLayout);
export var CartRegionModalLayoutRC = compose(connect(function (state) {
  return {
    isOpen: selectIsRegionModalOpen(state),
    status: selectFetchAllRegionsStatus(state)
  };
}, function (dispatch) {
  return {
    fetchAllRegions: function fetchAllRegions() {
      return dispatch(fetchCartRegionList());
    },
    toggleRegionModal: function toggleRegionModal() {
      return dispatch(_toggleRegionModal());
    }
  };
}))(RegionModalLayout);
export var ActionBarRC = compose(connect(null, function (dispatch) {
  return {
    onCloseButtonClick: function onCloseButtonClick() {
      return dispatch(_toggleRegionModal());
    }
  };
}))(ActionBar);
export var SearchRC = compose(connect(function (state) {
  return {
    searchValue: selectSearchValue(state)
  };
}, function (dispatch) {
  return {
    setSearchValue: function setSearchValue(searchValue) {
      return dispatch(_setSearchValue(searchValue));
    },
    onSearchChange: debounce(500, function (startsWith) {
      return dispatch(fetchSuggestionsRegions(startsWith));
    })
  };
}))(Search);
export var CartSearchRC = compose(connect(function (state) {
  return {
    searchValue: selectSearchValue(state)
  };
}, function (dispatch) {
  return {
    setSearchValue: function setSearchValue(searchValue) {
      return dispatch(_setSearchValue(searchValue));
    }
  };
}))(Search);
export var PopularRegionsRC = compose(connect(function (state) {
  return {
    popularRegions: selectPopularRegions(state),
    shouldRender: !!selectPopularRegions(state).length && !selectSearchValue(state)
  };
}), withRenderFlag)(PopularRegions);
export var SearchResultsRC = compose(connect(function (state) {
  return {
    suggestionsRegions: selectSuggestionsRegions(state),
    status: selectFetchSuggestionsRegionsStatus(state),
    shouldRender: selectSearchValue(state)
  };
}, function () {
  return {
    onClick: function onClick(region) {
      return changeRegion(region);
    }
  };
}), withRenderFlag)(SearchResults);
export var CartSearchResultsRC = compose(connect(function (state) {
  return {
    suggestionsRegions: selectCartSuggestionsRegions(state),
    status: EFetchStatus.loaded,
    shouldRender: selectSearchValue(state)
  };
}, function (dispatch) {
  return {
    onClick: function onClick(region) {
      return dispatch(regionClick(region));
    }
  };
}), withRenderFlag)(SearchResults);
export var RegionListRC = compose(connect(function (state, _ref) {
  var columns = _ref.columns;
  return {
    regions: selectRegions(columns)(state),
    shouldRender: !selectSearchValue(state)
  };
}, function () {
  return {
    onClick: function onClick(region) {
      return changeRegion(_objectSpread(_objectSpread({}, region), {}, {
        id: region.code
      }));
    }
  };
}), withRenderFlag)(RegionList);
export var CartRegionListRC = compose(connect(function (state, _ref2) {
  var columns = _ref2.columns;
  return {
    regions: selectRegions(columns)(state),
    shouldRender: !selectSearchValue(state)
  };
}, function (dispatch) {
  return {
    onClick: function onClick(region) {
      return dispatch(regionClick(region));
    }
  };
}), withRenderFlag)(RegionList);